export default __webpack_public_path__ + "static/media/purple1.410c9ec8.png";